import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
export const Contact = () => {
  
  const handleShareClick = () => {
    const textToShare = encodeURIComponent(
      'Check out this awesome link: https://example.com'
    );
    const whatsappUrl = `whatsapp://send?text=${textToShare}`;
    window.location.href = whatsappUrl;
  };
  const phoneNumber = '9926122299'; // Replace with the desired phone number
  const whatsappmessage = 'Hello, I would like to Enquire about your services.'; // Optional: Pre-filled message

  // WhatsApp API URL
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappmessage)}`;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [fullname, setFullname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");

  const [message, setMessage] = useState("");

  const [allValue, setAllValue] = useState([]);
  const contactfrom = useRef();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const modalStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };


  const modalContentStyles = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px',
    textAlign: 'center',
  };

  const formSubmit = (e) => {
    e.preventDefault();
    // Prevents page reload on form submission
    setIsModalVisible(true); // Show t
    emailjs
      .sendForm("service_be5k1s1", "template_618ra1q", contactfrom.current, {
        publicKey: "QSz0QsTM68Bd5HTY3",
      })
      .then(
        () => {

          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );

  };
  const closeModal = () => {
    setIsModalVisible(false);
  };
  
  // const formSubmit = (e) => {
  //   e.preventDefault();

  //   const newValue = { fullname, phone, email, subject, message };
  //   setAllValue([...allValue, newValue]);

  //   setFullname("");
  //   setPhone("");
  //   setEmail("");

  //   setMessage("");
  // };

  return (
    <>
      <div className="contact-section">
        <div className="section-header ">
          <h3>Contact Us</h3>
          <p>For more details contact now</p>
          <div className="line-mf"></div>

          {/* <p>More over 80,000+ happy students</p> */}
        </div>
        <div className="contactsus">
          <div className="contactus-container">
            <div className="contact-content">
              <div className="contact-cont">
                <div className="contact-box">
                  <div className="contactus-title">
                    <h3>Reach Us</h3>
                    <p>For more details contact now</p>
                  </div>
                  {/* <h4>Call Us</h4> */}
                  <div className="contact-us-box">
                    <i className="fa fa-map-marker-alt"></i>
                    <p>
                      <b>Earthy Fusion Pvt Ltd </b> <br />
                      G-2/50, Krishna Nagar, Sirsi Road, Vaishali Nagar, Jaipur,
                      Rajasthan – 302021
                    </p>
                  </div>
                  <div className="contact-us-box">
                    <i className="fa-regular fa-clock"></i>

                    <p>
                      Monday To Saturday
                      <br /> 09:00 AM - 07: 00 PM
                    </p>
                  </div>
                  <div className="contact-us-box">
                    <a className="topbar-item" href={whatsappUrl} target="_blank" rel="noopener noreferrer" >
                      <i className="fas fa-phone"></i>
                      <p>+91 992-612-2299</p>
                    </a>
                  </div>
                  <div className="contact-us-box">
                    <i className="fa fa-envelope"></i>

                    <p>
                      earthyfusionpvtltd@gmail.com,
                      <br />
                      Info@earthyfusionpvtltd.com
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-area">
              <div className="contact-form">
                <form
                  name="sentMessage"
                  id="contactForm"
                  onSubmit={formSubmit}
                  method="POST"
                  ref={contactfrom}
                >
                  <div className="control-group">
                    <input
                      type="text"
                      className="form-control p-4"
                      id="name"
                      name="from_name"
                      placeholder="Your Name"
                      value={fullname}
                      onChange={(e) => setFullname(e.target.value)}
                      required
                      data-validation-required-message="Please enter your name"
                    />
                    <p className="help-block text-danger"></p>
                  </div>
                  <div className="control-group">
                    <input
                      type="email"
                      name="from_email"
                      className="form-control p-4"
                      id="email"
                      placeholder="Your Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      data-validation-required-message="Please enter your email"
                    />
                    <p className="help-block text-danger"></p>
                  </div>

                  <div className="control-group">
                    <input
                      type="text"
                      className="form-control p-4"
                      id="phone"
                      placeholder="Phone"
                      name="from_mobile"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                      data-validation-required-message="Please enter a phone number"
                    />
                    <p className="help-block text-danger"></p>
                  </div>
                  <div className="control-group">
                    <input
                      type="text"
                      className="form-control p-4"
                      id="subject"
                      name="from_subject"
                      placeholder="Subject"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      required
                      data-validation-required-message="Please enter a subject"
                    />
                    <p className="help-block text-danger"></p>
                  </div>
                  <div className="control-group">
                    <textarea
                      className="form-control p-4"
                      rows="6"
                      id="message"
                      name="message"
                      placeholder="Message"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      required
                      data-validation-required-message="Please enter your message"
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div className="contact-btn1">
                    <button
                      onClick={handleShow}
                      className="btn1"
                      type="submit"
                      id="sendMessageButton"
                    >
                      Send Message
                    </button>
                  </div>
                </form>
                {isModalVisible && (
                  <div style={modalStyles}>
                    <div style={modalContentStyles}>
                      <h2>Success!</h2>
                      <p>Your form has been submitted successfully.</p>
                      <button className="success" onClick={closeModal}>Close</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
